export default "__VITE_ASSET__549d8962__"